import React,{useContext,useEffect,useState} from "react";
import { Dropdown, Menu, Button, message,notification } from "antd";
import { UnorderedListOutlined, CaretDownOutlined, FormOutlined,
    SettingOutlined, CarOutlined
 } from "@ant-design/icons";
import { SecurityContext } from "context/SecurityContextProvider";
import { ContratoVencidoService } from "services/ContratoVencidoService";
import EvaluacionService from "services/EvaluacionService";
import TipoDocumentoService from"services/TipoDocumentoService";
import { CategoriaDocumento } from "enums/CategoriaDocumento";
import { EstadoAprobacionEvaluacion } from "enums/EstadoAprobacionEvaluacion";
import { moment } from "moment";

const MenuAcciones = ({contrato}) =>{
    const { getUsuarioAutenticado } = useContext(SecurityContext);
    //const [evaluacionesPendientes,setEvaluacionesPendientes] = useState([]);

//   useEffect(()=>{
//      const datosIniciales = async()=>{
//        const evaluaciones= await EvaluacionService.listarPorcolaborador(contrato.numeroDocumentoIdentidadColaborador,EstadoAprobacionEvaluacion.PENDIENTE);
//        setEvaluacionesPendientes(evaluaciones);       
//      }
//       datosIniciales();
//   },[evaluacionesPendientes])

   const onClickMenu = (opcion) => {
        switch (opcion.key) {
            case 'notificar-evaluacion-desempenio':
                onClickNotificarEvaluacionDesempenio("GENERAL");
                break;
            case 'notificar-evaluacion-desempenio-conductor':
                onClickNotificarEvaluacionDesempenio("CONDUCTOR");
                break;
                case 'notificar-evaluacion-desempenio-mecanico':
            onClickNotificarEvaluacionDesempenio("MECANICO");
            break;           
            default:
                console.error("No se encuentra esa opción");
        }
    }
    const onClickNotificarEvaluacionDesempenio = async(tipo)=>{
        
        try {

            const evaluacionesPendientes= await EvaluacionService.listarPorcolaborador(contrato.numeroDocumentoIdentidadColaborador,EstadoAprobacionEvaluacion.PENDIENTE);
            if(evaluacionesPendientes.length>0){
                notification.error({
                    message: "Error al notificar la evaluación",
                    description: "Tiene una evaluación pendiente",
                  });
            }
            else{

                var fechaActual=(new Date().getMonth()+ 1).toString().length===1 ? "0"+(new Date().getMonth()+1):new Date().getMonth()+1;
                const tipoDocumentos = await TipoDocumentoService.listar(
                    getUsuarioAutenticado().empresaSeleccionada.id,
                    CategoriaDocumento.EVALUACION.id
                );

                let tipoDocumentoId = tipoDocumentos[0].id ;
                let tipoDocumentoNombre = tipoDocumentos[0].nombre;

                console.log("tipoDocumentos", tipoDocumentos);
                if(tipo === "CONDUCTOR"){
                    const documentoConductor = tipoDocumentos.find(doc => 
                        doc.nombre?.toLowerCase().includes("conductor")
                    );

                    tipoDocumentoId = documentoConductor?.id || null;
                    tipoDocumentoNombre = documentoConductor?.nombre || null;
                }else if(tipo === "MECANICO"){
                    const documentoMecanico = tipoDocumentos.find(doc => 
                        doc.nombre?.toLowerCase().includes("mecanico")
                    );

                    tipoDocumentoId = documentoMecanico?.id || null;
                    tipoDocumentoNombre = documentoMecanico?.nombre || null;
                }

                const evaluacion={
                periodo: fechaActual+"/"+new Date().getFullYear(),
                empresaId: getUsuarioAutenticado().empresaSeleccionada.id,
                organizacionId: getUsuarioAutenticado().organizacionId, 
                tipoDocumentoId: tipoDocumentoId ,            
                tipoDocumentoNombre: tipoDocumentoNombre,
                numeroDocumentoIdentidadColaborador:contrato.numeroDocumentoIdentidadColaborador,
                tipoEvaluacion : tipo,
                }             
                await ContratoVencidoService.insertarEvaluacion(evaluacion);
                notification["success"]({
                    message: "Notificación enviada",
                    description: "Se ha enviado la evaluación exitosamente.",
                });

                }

            
             
        } catch (error) {
            console.error(error);
            if(error.response!= null && error.response.data!= null ){
                notification.error({
                    message: "Error al notificar la evaluación",
                    description: error.response.data.mensaje,
                  });
            }else{
                notification.error({
                    message: "Error al notificar la evaluación",
                    description: "Error al notificar la evaluación",
                  });
            }
        }     
     
    }    

    const menu =() => {        
        
        return (                  
            <Menu onClick={onClickMenu}>              
                {/* {evaluacionesPendientes.length===0 && */}
                    <Menu.Item key="notificar-evaluacion-desempenio">
                    <FormOutlined /> Notificar Evaluación desempeño
                    </Menu.Item>               
               
                    <Menu.Item key="notificar-evaluacion-desempenio-conductor">
                    <CarOutlined /> Notificar Evaluación desempeño conductor
                    </Menu.Item>

                    <Menu.Item key="notificar-evaluacion-desempenio-mecanico">
                    <SettingOutlined /> Notificar Evaluación desempeño mecánico
                    </Menu.Item>
                {/* } */}
            </Menu>
            
            
        )
    }
    return(              
        <Dropdown
                overlay={menu}                
                trigger={['click']}
                placement="bottomCenter">

                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                    <UnorderedListOutlined style={{ fontSize: '16px', fontWeight: 'bold', color: "#1678c1" }} />
                    <CaretDownOutlined style={{ paddingLeft: '2px', fontSize: '12px', fontWeight: 'bold', color: "#1678c1" }} />
                </a>

            </Dropdown>
        
    )

}
export default MenuAcciones;